import { CopiarEventoFormModel } from "../modelos/evento/copiarEventoFormModel";

export const COPIAR_EVENTO_FORM_INITIAL_STATE: CopiarEventoFormModel = {
    idEvento: "",
    novaUrl: "",
    
  };
  